import { useContext } from 'react';

import { CategoricalBarChartTooltipContext } from '../contexts/CategoricalBarChartTooltip.context.js';

export const useCategoricalBarChartTooltip = () =>
  useContext(CategoricalBarChartTooltipContext);
